<template>
    <el-dialog :visible.sync="show"
        :title="$t('privateNetInstance.haveSOS')"
        :close-on-click-modal="false"
        :before-close="handleClose"
        class="del-root">
        <div class="i-text">
                <div class="tip-warning mb20 lh20"
                >{{$t('privateNetInstance.fixSOSTips1')}}
                  <a v-bind:href="Config.SOS_URL" target="_blank">{{$t('privateNetInstance.operateGuid')}}</a>{{'。'}}
                </div>    
            </div>
        <p>{{ $t('privateNetInstance.SOScontent') }}</p>
        <span>{{`ssh ${rowInfo.instanceId}@sos.cpsoob.jdcloud.com -p 20000`}}</span>
        <copy-value :copyVal="`ssh ${rowInfo.instanceId}@sos.cpsoob.jdcloud.com -p 20000`"></copy-value>
        <div slot="footer" class="dialog-footer">
            <el-button @click="cancel">{{ $t('slb.text.closed') }}</el-button>
        </div>
    </el-dialog>
</template>

<script>
import copyValue from '@/components/privateNetwork/CopyValue';
export default {
    name: 'HaveSos',
    components: {copyValue},
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        rowInfo: {
            type:Object,
            default:{}
        }
    },
    data() {
        return {
            show: false
        };
    },
    watch: {
        visible(newVal) {
            this.show = newVal;
        }
    },
    methods: {
        handleClose() {
            this.show = false;
            this.$emit('update:visible', false);
        },
        cancel() {
            this.handleClose();
        },
    },
};
</script>

<style scoped lang="scss">
    .del-root {
        p {
            text-align: left;
            margin: 12px;
            line-height: 1.5;
            color: #212121;
            word-break: break-all;
            font-size: 14px;
        }

        span {
            text-align: left;
            margin: 12px;
            line-height: 1.5;
            color: #212121;
            word-break: break-all;
            font-size: 14px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/common/HaveSos.vue